/*
 * Kept apart from the pages: the router validates `?tab=` and `?scope=` with
 * them, and importing them from a page would pull that lazily loaded page into
 * the start-up bundle.
 */

/** Tabs of a project's alerts page. */
export const PROJECT_ALERT_TABS = ["active", "history", "rules", "silences", "channels"] as const;
export type ProjectAlertTab = (typeof PROJECT_ALERT_TABS)[number];

/**
 * Whose alerts the project's page shows (owner's decision 2026-10-22): this
 * project, or the whole organisation — every project the person sees and the
 * organisation's rules.
 */
export const ALERT_SCOPES = ["project", "organization"] as const;
export type AlertScope = (typeof ALERT_SCOPES)[number];

/** The tabs of the organisation scope; silences and channels belong to one project. */
export const ORG_SCOPE_TABS: readonly ProjectAlertTab[] = ["active", "history", "rules"];

/**
 * Tabs of the former organisation page `/alerts` (gone 2026-10-22), still read
 * from old links: `channels` (the bots) now lives in «API и интеграции ›
 * Мессенджеры», the rest in a project's page with the organisation scope.
 */
export const LEGACY_ORG_ALERT_TABS = ["active", "history", "rules", "channels"] as const;
export type LegacyOrgAlertTab = (typeof LEGACY_ORG_ALERT_TABS)[number];
